module.exports = "<app-advertisements></app-advertisements>\r\n<app-brand-features></app-brand-features>\r\n<app-about-brand></app-about-brand>\r\n<app-brand-salles-of></app-brand-salles-of>\r\n<app-brand-by-category></app-brand-by-category>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/brand-page/brand-page.component.html
// module id = ./src/app/pages/brand-page/brand-page.component.html
// module chunks = main